import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { class: "pagination-info" }
const _hoisted_3 = { class: "flex gap-16" }


export default /*#__PURE__*/_defineComponent({
  __name: 'acPagination',
  props: ["currentPage", "totalPages", ],
  emits: ["navigateToPage"],
  setup(__props, { emit: __emit }) {


const props = __props
const emit = __emit

function navigateToPage(pageNumber: number) {
    emit("navigateToPage", pageNumber)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Sayfa " + _toDisplayString(props.currentPage) + " / " + _toDisplayString(props.totalPages), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateToPage(props.currentPage - 1))),
        class: _normalizeClass({'hidden': props.currentPage === 1})
      }, "< Daha Yeni Kayıtlar", 2),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateToPage(props.currentPage + 1))),
        class: _normalizeClass({'hidden': props.currentPage === props.totalPages})
      }, "Daha Eski Kayıtlar >", 2)
    ])
  ]))
}
}

})